// extracted by mini-css-extract-plugin
export default {"Image":"InformationModal_Image__j4bWr"};